export const environment = {
  production: true,
  workerEnabled: true,
  channelsVersion: '2026.2.0.966',
  apiUrl: 'assets/data/appConfig-production.json'
};
